import { getBeneficiariesBySubmission } from "./getBeneficiariesBySubmission"
import { getProjectBeneficiariesByProject } from "./getProjectBeneficiariesByProject"
import { addBeneficiaryProfileToProjectBeneficiary } from "./addBeneficiaryProfileToProjectBeneficiary"
import { graphqlApolloClient } from "../graphql-apollo-client"
import {
  GET_PROJECT_BENEFICIARIES_COUNT_BY_PREVENTION_LEVEL
} from "./graphql/queries/get-project-beneficiaries-count-by-prevention-level"
import { getProjectBeneficiariesWithAttendance } from "./getProjectBeneficiariesWithAttendance"
import { getProjectBeneficiariesWithActivities } from "./getProjectBeneficiariesWithActivities"

export const BeneficiariesService = () => {
  const getProjectBeneficiariesCountByPreventionLevel = async ({ submissionId }) => {
    const res = await graphqlApolloClient.query({
      query: GET_PROJECT_BENEFICIARIES_COUNT_BY_PREVENTION_LEVEL,
      fetchPolicy: "network-only",
      variables: {
        submissionId
      }
    })
    return res?.data?.ProjectBeneficiariesCountByPreventionLevelAndAgeRange
  }

  return {
    getBeneficiariesBySubmission,
    getProjectBeneficiariesByProject,
    addBeneficiaryProfileToProjectBeneficiary,
    getProjectBeneficiariesCountByPreventionLevel,
    getProjectBeneficiariesWithAttendance,
    getProjectBeneficiariesWithActivities
  }
}
